// @flow
/* eslint react/require-default-props: 0 */

import React, { Component } from 'react';
import type { ComponentType } from 'react';
import { number as numberValidator } from '../../../helpers/formValidators';

type HOCProps = {
  invalidError?: string,
  validate?: Array<Function>,
};

function withNumber<Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Props & HOCProps> {
  return class WithNumber extends Component<Props & HOCProps> {
    validators: Array<Function>;

    constructor(props) {
      super(props);
      this.validators = [...props.validate, numberValidator(props.invalidError)];
    }

    render() {
      const {
        invalidError,
        validate,
        ...otherProps
      } = this.props;

      return (
        <WrappedComponent
          validate={this.validators}
          {...otherProps}
        />
      );
    }
  };
}

withNumber.defaultProps = {
  invalidError: '',
  validate: [],
};

export default withNumber;
